import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { NotesService } from 'src/app/shared/services/notesservices/notes.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { NoticeSectionComponent } from '../sub-components/notice-sections/notice-section.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, LoaderComponent, CollapseModule, NoticeSectionComponent]
})
export class MainComponentNotes implements OnInit {
  public showSpinner = true;
  noticeArr: any = [];
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  constructor(private noteServices: NotesService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    this.getNotesData();
  }

  ngOnInit(): void {
    this.getNotesData(); this.sharedmode.data$.subscribe(mode => {

      this.selectedMode = mode;
    });
  }

  getNotesData() {
    this.noteServices.getNotes().then((value) => {
      if (value.success == true) {
        this.noticeArr = value.data;
        this.showSpinner = false;
      }
    });
  }

  onSubmit(f: NgForm) {
    this.showSpinner = true;
    this.noticeArr = [];
    this.noteServices
      .getNotesFilter(f.value.date, f.value.month, f.value.year)
      .then((value) => {
        //  alert('value');
        this.showSpinner = false;
        this.noticeArr = value.data;
      });
  }

  onReset() {
    // alert('here');
    this.showSpinner = true;

  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }

}
